import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { CardNumberElement, useElements, useStripe } from '@stripe/react-stripe-js';
import { Row, Column } from '@narvar/nth-grid';
import { getStripeConfig } from '../index';
import ConfirmButton from './ConfirmButton';
import StripeHeader from './StripeHeader';
import StripeForm from './StripeForm';
import StripeFooter from './StripeFooter';

export const mapStateToProps = ({ stripeWidget = [] }) => ({
  stripeWidget,
});

const CardCapture = ({
  onClick,
  onSuccess,
  onError,
  disabled,
  confirmingCard,
  id,
  stripeWidget,
  aboveSubmitContent: AboveSubmitContent,
  hideSubmit,
}) => {
  const { serviceFee, paymentIntentSecret } = getStripeConfig({ id, stripeWidget });
  const stripe = useStripe();
  const [validationError, setValidationError] = useState('');
  const [serverError, setServerError] = useState('');
  const elements = useElements();

  // POST the token ID to your backend.
  const confirmPayment = async () => {
    if (!elements) return;
    const cardElement = elements.getElement(CardNumberElement);
    if (!stripe || !cardElement) return;
    if (onClick) onClick();
    try {
      const result = await stripe.confirmCardPayment(paymentIntentSecret, {
        payment_method: {
          card: cardElement,
        },
      });

      if (result.error && result.error.message) {
        setServerError(result.error.message);
        onError();
      } else {
        setServerError('');
        if (typeof onSuccess === 'function') {
          onSuccess();
        }
      }
    } catch (e) {
      setServerError('Something went wrong');
      onError();
    }
  };

  const handleChange = (event) => {
    if (event.error) {
      setValidationError(event.error.message);
    } else {
      setValidationError('');
    }
  };

  return (
    <div data-test="stripe-card-capture">
      <StripeHeader {...{ serviceFee, id }} />
      <Row>
        <Column md-columns={8} md-column-offset={2}>
          <StripeForm {...{ id, handleChange, validationError, serverError }} />
        </Column>
      </Row>
      {AboveSubmitContent || null}
      {!hideSubmit && (
        <Row style={{ margin: '2rem auto' }}>
          <Column md-columns={8} md-column-offset={2}>
            <ConfirmButton
              {...{
                id,
                confirmPayment,
                validationError,
                confirmingCard,
                disabled,
              }}
            />
          </Column>
        </Row>
      )}
      <StripeFooter {...{ id }} />
    </div>
  );
};

CardCapture.defaultProps = {
  onClick: () => {},
  onSuccess: () => {},
  onError: () => {},
  confirmingCard: false,
  disabled: false,
  aboveSubmitContent: null,
  hideSubmit: false,
};

CardCapture.propTypes = {
  onClick: PropTypes.func,
  onSuccess: PropTypes.func,
  onError: PropTypes.func,
  confirmingCard: PropTypes.bool,
  disabled: PropTypes.bool,
  id: PropTypes.string.isRequired,
  stripeWidget: PropTypes.arrayOf(
    PropTypes.shape({
      paymentIntentSecret: PropTypes.string.isRequired,
      publishableKey: PropTypes.string.isRequired,
      completedPayment: PropTypes.bool.isRequired,
      serviceFee: PropTypes.number.isRequired,
      errorMessage: PropTypes.string.isRequired,
    }),
  ).isRequired,
  aboveSubmitContent: PropTypes.node,
  hideSubmit: PropTypes.bool,
};

export default connect(mapStateToProps)(CardCapture);
